import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-farm-list',
template: templateSource || '',
    styles: [``],
})
export class PortalFarmListComponent implements OnInit {

    public list: any[] = [];
    public search: any = { page: 1, text: '' };
    public facet: any = { lastpage: 1 };

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    public async ngOnInit() {
        await this.service.init();

        if (wiz.options?.search) {
            this.search.page = wiz.options.search.page || 1;
            this.search.text = wiz.options.search.text || '';
        }

        await this.load();
        await this.service.render();
    }

    public async load() {
        const res = await wiz.call('search', this.search);
        if (res.code === 200) {
            this.list = res.data.list;
            this.facet.lastpage = res.data.lastpage;
        }
    }

    public async searchAction() {
        this.search.page = 1;
        await this.load();
        await this.service.render();
    }

    public async page(p: number) {
        if (p < 1 || p > this.facet.lastpage) return;
        this.search.page = p;
        await this.load();
        await this.service.render();
    }

    public select(item: any) {
        this.router.navigate([
            '/admin/farm/dashboard',
            item.farm_id
        ]);
    }

    public onPageChange = async (page: number) => {
        await this.page(page);
    }
}

export default PortalFarmListComponent;